import { Info } from 'lucide-react';

import { ColorPicker } from '@/components/color-picker/ColorPicker';
import { FileUpload } from '@/components/file-upload/FileUpload';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

import { MODULE_STYLE_OPTIONS } from '../config/styles';
import { MODULE_STYLES, type ModuleStyle } from '../domain/types';
import { useQrContext } from '../state/qr-context';

function isModuleStyle(value: string): value is ModuleStyle {
  return (MODULE_STYLES as readonly string[]).includes(value);
}

export function ModuleSettings() {
  const { design, actions } = useQrContext();
  const active = MODULE_STYLE_OPTIONS.find((option) => option.value === design.moduleStyle);

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="module-style">Modul-Stil</Label>
        <Select
          value={design.moduleStyle}
          onValueChange={(value) => {
            if (isModuleStyle(value)) actions.setModuleStyle(value);
          }}
        >
          <SelectTrigger id="module-style">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="max-h-72">
            {MODULE_STYLE_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        {active !== undefined && (
          <p className="text-xs text-muted-foreground">{active.description}</p>
        )}
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        <ColorPicker
          label="Modul-Farbe"
          value={design.moduleColor}
          onChange={actions.setModuleColor}
        />
        <ColorPicker
          label="Hintergrund"
          value={design.backgroundColor}
          onChange={actions.setBackgroundColor}
        />
      </div>

      <FileUpload
        label="Eigenes Modul-Bild (optional)"
        selectedFile={design.customModuleImage}
        onSelect={actions.setCustomModuleImage}
        onRemove={() => {
          actions.setCustomModuleImage(null);
        }}
      />

      {design.customModuleImage !== null && (
        <Alert variant="warning">
          <Info aria-hidden="true" />
          <AlertDescription>
            Das Bild ersetzt alle Module und wird beim SVG-Export als Rasterbild eingebettet. Die
            Lesbarkeit kann darunter leiden — teste den Code anschließend mit dem Scanner.
          </AlertDescription>
        </Alert>
      )}
    </div>
  );
}
